export default "__VITE_ASSET__CjVp5B_l__"